import { createFormHookContexts } from '@tanstack/react-form'

// own file to avoid circular dependencies
export const { fieldContext, formContext, useFormContext } = createFormHookContexts()
